import InnerBanner from "../Components/InnerBanner/InnerBanner";
import GetStarted from "../Components/GetStarted/GetStarted";
import RecentBlog from "../Components/RecentBlog/RecentBlog";
import {Link} from "react-router-dom";

function Grad() {
    return (
        <>
            <InnerBanner
                img_url='gradBanner.webp'
                heading={'Hire Our Grads'}
            />
            <section className='multiContent'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <figure className="imgCont" data-aos='fade-in' data-aos-delay='100'>
                                <img src={process.env.PUBLIC_URL + "/images/grad1.webp"} alt=""/>
                            </figure>
                        </div>
                        <div className="col-md-6">
                                <span className="tag" data-aos='fade-up' data-aos-delay='50'>
                                    Unlocking Potential
                                </span>
                            <h3 data-aos='fade-up' className="heading">Hire Our Skill Bridge Graduates</h3>
                            <p data-aos='fade-up' data-aos-delay='100' className="description med">
                                Are you in search of fresh talent to elevate your business to new heights? Look no
                                further than Skill Bridge. Our graduates are your gateway to a pool of skilled,
                                passionate, and future-focused professionals ready to contribute to your success.
                            </p>
                            <h3 data-aos='fade-up' data-aos-delay='150' className="heading">Why Choose Our Graduates?</h3>
                            <p data-aos='fade-up' data-aos-delay='200' className="description med">
                                At Skill Bridge., we don't just train; we transform. Our programs are designed to
                                nurture and cultivate top-tier DevOps engineers. When you hire our graduates, you're not
                                just getting a candidate; you're gaining a partner in innovation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="expertiseSec">
                <div className="container">
                    <div className="title center">
                        <h2 className="secHeading" data-aos='fade-up' >
                            Expertise Meets Practicality
                        </h2>
                        <p data-aos='fade-up' data-aos-delay='100'>
                            Our graduates are equipped with hands-on experience that translates seamlessly into
                            real-world
                            scenarios. They bring not just theoretical knowledge but the practical skills to drive
                            your projects forward from day one.
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-sm-6">
                            <div className="expertCard" data-aos='fade-out'>
                                <div className="head">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + "/images/expertise1.webp"} alt=""/>
                                    </figure>
                                </div>
                                <div className="content">
                                    <h6 className="heading">
                                        Adaptability
                                    </h6>
                                    <p>
                                        In the ever-changing tech landscape, adaptability is key. Our graduates are
                                        well-versed in the latest industry trends,
                                    </p>
                                    <Link to="" className="learnBtn">
                                        <span>Learn More</span>
                                        <i className="fas fa-chevron-right"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="expertCard" data-aos='fade-out'>
                                <div className="head">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + "/images/expertise2.webp"} alt=""/>
                                    </figure>
                                </div>
                                <div className="content">
                                    <h6 className="heading">
                                        Problem Solvers
                                    </h6>
                                    <p>
                                        DevOps is about more than just technology; it's about problem-solving. Our
                                        graduates are adept at identifying and addressing issues
                                    </p>
                                    <Link to="" className="learnBtn">
                                        <span>Learn More</span>
                                        <i className="fas fa-chevron-right"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="expertCard" data-aos='fade-out'>
                                <div className="head">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + "/images/expertise3.webp"} alt=""/>
                                    </figure>
                                </div>
                                <div className="content">
                                    <h6 className="heading">
                                        Collaborative Spirits
                                    </h6>
                                    <p>
                                        Collaboration is at the heart of DevOps, and our graduates understand its
                                        importance. They thrive in team environments,
                                    </p>
                                    <Link to="" className="learnBtn">
                                        <span>Learn More</span>
                                        <i className="fas fa-chevron-right"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="expertCard" data-aos='fade-out'>
                                <div className="head">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + "/images/expertise4.webp"} alt=""/>
                                    </figure>
                                </div>
                                <div className="content">
                                    <h6 className="heading">
                                        Innovation-Driven
                                    </h6>
                                    <p>
                                        We foster innovation at Skill Bridge., and it's a trait our graduates carry with
                                        them. They bring fresh ideas, perspectives,
                                    </p>
                                    <Link to="" className="learnBtn">
                                        <span>Learn More</span>
                                        <i className="fas fa-chevron-right"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="expertCard" data-aos='fade-out'>
                                <div className="head">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + "/images/expertise5.webp"} alt=""/>
                                    </figure>
                                </div>
                                <div className="content">
                                    <h6 className="heading">
                                        Diversity and Inclusion
                                    </h6>
                                    <p>
                                        Our diverse pool of graduates brings a wealth of perspectives to your team. We
                                        believe in the power of inclusion,
                                    </p>
                                    <Link to="" className="learnBtn">
                                        <span>Learn More</span>
                                        <i className="fas fa-chevron-right"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="expertCard" data-aos='fade-out'>
                                <div className="head">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + "/images/expertise6.webp"} alt=""/>
                                    </figure>
                                </div>
                                <div className="content">
                                    <h6 className="heading">
                                        Ready to Make an Impact
                                    </h6>
                                    <p>
                                        Our graduates aren't just looking for jobs; they're looking for opportunities to
                                        make an impacts. When you hire from Skill Bridge.,
                                    </p>
                                    <Link to="" className="learnBtn">
                                        <span>Learn More</span>
                                        <i className="fas fa-chevron-right"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <GetStarted
                mainImg="benefitImg.webp"
                heading="How to Get Started"
                descClass={'descClass'}
                description={[
                    'Hiring our graduates is a straightforward process. Reach out to us today to discuss your hiring needs, and we\'ll connect you with the best-fit candidates from our pool. Whether you\'re looking for entry-level talent or individuals with more experience, Skill Bridge. has the right fit for your organization.',
                    'Invest in the future of your business by hiring graduates who have been shaped by Skill Bridge.\'s cutting-edge training and commitment to excellence. Join us in propelling your business forward with the next generation of DevOps talent.',
                    'Unlock the potential of our graduates today and experience the transformative impact they can bring to your organisation. Contact us now to explore your hiring options and start building a brighter future together.'
                ]}
            />

            <RecentBlog/>
        </>
    )
}

export default Grad